__turbopack_context__.v({
  "className": "noto_sans_malayalam_aeec460c-module__YjDcEq__className",
});
